import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import moment from 'moment';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import Creatable from 'react-select/lib/Creatable';
import makeAnimated from 'react-select/lib/animated';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Modal, ModalHeader, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Configurations } from '../../../Utils/Configurations';
import ImagesUpload from '../../../Components/Images-Upload/Images-Upload';
import ImagemFukyo from '../../../Components/Imagem-Fukyo/Imagem-Fukyo';
import ModalQRCode from '../../../Components/Modal-QRCode/Modal-QRCode';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import SuccessModal from '../../../Components/SuccessModal/SuccessModal';
import ModalPdfsAdicionais from '../../../Components/Modal-Pdfs-Adicionais/Modal-Pdfs-Adicionais';
import ArticleTextEditor from '../../../Components/Article-Text-Editor/Article-Text-Editor';

const autorOptions = [
    { label: "Redação", value: "Redação" },
    { label: "Colaboração local", value: "Colaboração local" },
    { label: "Colaboração", value: "Colaboraçao" },
    { label: "Departamento de Estudo da BSGI", value: "Departamento de Estudo da BSGI" },
    { label: "Daisaku Ikeda", value: "Daisaku Ikeda" },
    { label: "Dr. Daisaku Ikeda", value: "Dr. Daisaku Ikeda" },
    { label: "Presidente da BSGI", value: "Presidente da BSGI" },
    { label: "Presidente Harada", value: "Presidente Harada" },
    { label: "Miguel Shiratori", value: "Miguel Shiratori" },
];

const toolbarSimples = {
    inline: { inDropdown: false, options: ['bold', 'italic', 'underline', 'subscript', 'superscript'] },
    blockType: { inDropdown: true, options: [], className: 'd-none' },
    fontSize: { className: 'd-none' },
    fontFamily: { className: 'd-none' },
    list: { options: [] },
    textAlign: { options: ['center'] },
    colorPicker: { className: 'd-none' },
    link: { className: 'd-none' },
    emoji: { className: 'd-none' },
    embedded: { className: 'd-none' },
    image: { className: 'd-none' },
    remove: {},
    history: { inDropdown: false, options: ['undo', 'redo'] },
};

// Editor pequeno (Descrição e Legenda da capa), sem embeds — o texto principal usa ArticleTextEditor.
// editorClassName segue a mesma distinção de Article-Details.js: custom-editor-descricao (maior) e
// custom-editor-legenda (menor) — o estilo de ambos só existe dentro de .article-details.
function SimpleHtmlEditor({ value, onChange, editorClassName, disabled }) {
    const [editorState, setEditorState] = useState(() => {
        if (!value) return EditorState.createEmpty();
        const blocks = htmlToDraft(value);
        if (!blocks || !blocks.contentBlocks) return EditorState.createEmpty();
        return EditorState.createWithContent(ContentState.createFromBlockArray(blocks.contentBlocks));
    });

    const handleChange = (newState) => {
        setEditorState(newState);
        onChange(draftToHtml(convertToRaw(newState.getCurrentContent())));
    };

    return (
        <Editor
            readOnly={disabled}
            editorState={editorState}
            wrapperClassName="demo-wrapper"
            onEditorStateChange={handleChange}
            toolbar={toolbarSimples}
            toolbarClassName={`custom-toolbar ${disabled ? 'd-none' : ''}`}
            editorClassName={editorClassName}
            handlePastedText={() => false}
        />
    );
}

const mensagemDeErro = (err, padrao) => (err && err.response && err.response.data && err.response.data.message) || padrao;
const mensagemDeSucesso = (response, padrao) => (response && response.data && response.data.message) || padrao;

const UnlistedArticleDetails = ({ history, match }) => {

    const configurations = new Configurations();
    const idConteudo = match.params.idArtigo;
    const novoConteudo = idConteudo === 'novo';

    const [loading, setLoading] = useState(!novoConteudo);
    const [salvando, setSalvando] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [abaSelecionada, setAbaSelecionada] = useState('1');

    const [contentId, setContentId] = useState(idConteudo || null);
    const [titulo, setTitulo] = useState('');
    const [descricaoHtml, setDescricaoHtml] = useState('');
    const [imagemCapa, setImagemCapa] = useState('');
    // valor gravado no banco: permite desfazer a remoção enquanto ela não for salva
    const [imagemCapaSalva, setImagemCapaSalva] = useState('');
    const [pdf, setPdf] = useState('');
    const [downloadHabilitado, setDownloadHabilitado] = useState(false);
    const [pdfRemovido, setPdfRemovido] = useState(false);
    const [modalPdf, setModalPdf] = useState(false);
    const [legendaCapaHtml, setLegendaCapaHtml] = useState('');
    const [textoHtml, setTextoHtml] = useState('');
    const [autorSelecionado, setAutorSelecionado] = useState(null);
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');

    const [codigo, setCodigo] = useState(null);
    const [ativo, setAtivo] = useState(false);
    const [dtModificacao, setDtModificacao] = useState(null);
    const [foiSalvo, setFoiSalvo] = useState(!novoConteudo);

    const [openModalImagemCapa, setOpenModalImagemCapa] = useState(false);
    const [modalQRCode, setModalQRCode] = useState(false);

    // O ModalPdfsAdicionais trabalha com uma lista e só a recopia quando a referência muda (componentDidUpdate).
    const arquivosPdf = useMemo(() => (pdf && !pdfRemovido ? [{ _id: 'pdf', titulo: 'PDF do conteúdo', arquivo: pdf, downloadHabilitado }] : []), [pdf, pdfRemovido, downloadHabilitado]);

    const [estatisticas, setEstatisticas] = useState([]);


    // Só atualiza os campos de status/metadados; os editores (SimpleHtmlEditor/ArticleTextEditor) leem o
    // valor inicial apenas na montagem, então o conteúdo editável é preenchido somente no carregamento.
    const atualizaMetadados = (item) => {
        setContentId(item._id);
        setCodigo(item.codigo || null);
        setAtivo(!!item.ativo);
        setDtModificacao(item.dtModificacao || null);
    };

    useEffect(() => {
        if (novoConteudo) return;
        setLoading(true);
        setHasError(false);
        axios.get(`${configurations.apiBasePath}/conteudo/nao-listados/${idConteudo}`)
            .then(response => {
                const item = response.data.conteudo;
                if (!item || !item._id) {
                    setHasError(true);
                    setErrorMessage('Não foi possível carregar as informações do conteúdo.');
                    return;
                }
                atualizaMetadados(item);
                setTitulo(item.titulo || '');
                setDescricaoHtml(item.descricao || '');
                setImagemCapa(item.imagem || '');
                setImagemCapaSalva(item.imagem || '');
                setImagemCapaSalva(item.imagem || '');
                setLegendaCapaHtml(item.legendaCapa || '');
                setTextoHtml(item.texto || '');
                setAutorSelecionado(item.autor ? { label: item.autor, value: item.autor } : null);
                setMetaTitle(item.metaTitle || '');
                setMetaDescription(item.metaDescription || '');
                setPdf(item.arquivoPdf || '');
                setDownloadHabilitado(!!item.downloadHabilitado);
                setEstatisticas({ 'acessos': item.qtdAcessos, 'downloads': item.qtdDownloads });
            })
            .catch(err => {
                console.error('Erro ao carregar conteúdo não listado', err);
                setHasError(true);
                setErrorMessage(mensagemDeErro(err, 'Não foi possível carregar as informações do conteúdo.'));
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idConteudo]);

    const handleChangeAutor = (newValue, actionMeta) => {
        switch (actionMeta.action) {
            case 'clear': setAutorSelecionado(null); break;
            case 'select-option': setAutorSelecionado({ value: newValue.value, label: newValue.label }); break;
            case 'create-option': setAutorSelecionado({ label: newValue.label, value: newValue.label }); break;
            default: setAutorSelecionado(null); break;
        }
    };

    const fecharErrorModal = () => { setHasError(false); setErrorMessage(''); };

    const voltar = () => history.push('/nao-listados');

    const salvar = () => {
        if (!titulo || titulo.trim() === '') {
            setHasError(true);
            setErrorMessage('O título é obrigatório.');
            return;
        }

        setSalvando(true);

        const dados = {
            titulo: titulo.trim(),
            descricao: descricaoHtml,
            imagem: imagemCapa,
            legendaCapa: legendaCapaHtml,
            texto: textoHtml,
            autor: autorSelecionado ? autorSelecionado.value : '',
            metaTitle,
            metaDescription,
        };
        // o PDF é gravado pelo upload; só é enviado no salvar quando a remoção foi pedida
        if (pdfRemovido) dados.arquivoPdf = '';

        const requisicao = novoConteudo
            ? axios.post(`${configurations.apiBasePath}/conteudo/nao-listados`, dados)
            : axios.put(`${configurations.apiBasePath}/conteudo/nao-listados/${contentId}`, dados);

        requisicao
            .then(response => {
                const item = response.data.conteudo;
                atualizaMetadados(item);
                // sincroniza com o que o banco gravou: se a API ignorar a remoção, a imagem/PDF volta a aparecer
                setImagemCapa(item.imagem || '');
                setImagemCapaSalva(item.imagem || '');
                setPdf(item.arquivoPdf || '');
                setDownloadHabilitado(!!item.downloadHabilitado);
                setPdfRemovido(false);
                setFoiSalvo(true);
                setSuccessMessage(mensagemDeSucesso(response, novoConteudo ? 'Conteúdo criado com sucesso.' : 'Alterações salvas com sucesso.'));
                if (novoConteudo) history.replace(`/nao-listados/${item._id}`);
            })
            .catch(err => {
                console.error('Erro ao salvar conteúdo não listado', err);
                setHasError(true);
                setErrorMessage(mensagemDeErro(err, 'Não foi possível salvar o conteúdo.'));
            })
            .finally(() => setSalvando(false));
    };

    // O upload já grava o PDF no conteúdo (arquivoPdf) — não depende de "salvar alterações".
    const onUploadPdf = (dados) => {
        const item = dados && dados.conteudo;
        if (!item) return;
        atualizaMetadados(item);
        setPdf(item.arquivoPdf || '');
        setDownloadHabilitado(!!item.downloadHabilitado);
        setPdfRemovido(false);
        setModalPdf(false);
        setSuccessMessage(dados.message || 'PDF enviado com sucesso.');
    };

    // Chamado pelo ModalPdfsAdicionais (que controla o spinner e exibe o erro); por isso retorna a promise.
    const alteraDownloadPdf = (_item, habilitado) =>
        axios.post(`${configurations.apiBasePath}/conteudo/nao-listados/${contentId}/status-download`, { downloadHabilitado: habilitado })
            .then(response => {
                const item = response.data.conteudo;
                atualizaMetadados(item);
                setDownloadHabilitado(!!item.downloadHabilitado);
            });

    const mudaStatusConteudo = (metodo) => {
        setLoadingStatus(true);
        axios.post(`${configurations.apiBasePath}/conteudo/nao-listados/${contentId}/${metodo}`)
            .then(response => {
                atualizaMetadados(response.data.conteudo);
                setSuccessMessage(mensagemDeSucesso(response, metodo === 'publicar' ? 'Conteúdo publicado com sucesso.' : 'Conteúdo desativado com sucesso.'));
            })
            .catch(err => {
                console.error(`Erro ao ${metodo} conteúdo não listado`, err);
                setHasError(true);
                setErrorMessage(mensagemDeErro(err, 'Não foi possível alterar o status do conteúdo.'));
            })
            .finally(() => setLoadingStatus(false));
    };

    const botaoStatus = (mobile) => {
        if (loadingStatus) return <div className="spinner-border spinner-border-sm mx-3 text-primary" role="status" />;
        return ativo ? (
            <button disabled={salvando} onClick={() => mudaStatusConteudo('desativar')} className="btn btn-outline-danger mx-1 text-nowrap">
                {mobile ? 'desativar' : 'desativar conteúdo'}
            </button>
        ) : (
            <button disabled={salvando || novoConteudo} onClick={() => mudaStatusConteudo('publicar')} className="btn btn-outline-primary mx-1 text-nowrap">
                {mobile ? 'publicar' : 'publicar conteúdo'}
            </button>
        );
    };

    const badgeStatus = novoConteudo
        ? { texto: 'Novo conteúdo', className: 'secondary badge-opacity' }
        : ativo
            ? { texto: 'Disponível', className: 'primary' }
            : { texto: 'Indisponível', className: 'secondary badge-opacity' };

    const linkPublico = codigo ? `${configurations.hkWebClient}/conteudo/${codigo}` : null;

    return (
        <div className="row article-details">
            {!loading && (
                <>
                    {/* Layout desktop */}
                    <div className="header-cadastro border-left border-bottom border-gray d-lg-block d-none">
                        <div className="row no-gutters py-3 h-100 align-items-center">
                            {/* O header tem altura fixa (80px, overflow hidden): no máximo 2 linhas à esquerda e botões sem quebra à direita */}
                            <div className="col-5 px-3">
                                <p className="m-0 text-nowrap">
                                    <span className="badge badge-info mr-2">Conteúdo Não Listado</span>
                                    Status: <span className={`badge badge-${badgeStatus.className}`}>{badgeStatus.texto}</span>
                                </p>
                                {!novoConteudo && dtModificacao && (
                                    <p className="m-0">Última modificação: {moment(dtModificacao).format('DD/MM/YYYY H:mm:ss')}</p>
                                )}
                            </div>
                            <div className="col-7 px-3 d-flex justify-content-end align-items-center flex-nowrap">
                                {foiSalvo && linkPublico && (
                                    <button onClick={() => setModalQRCode(true)} className="btn btn-outline-info mx-1" title="QR Code">
                                        <i className="fas fa-qrcode pr-1"></i> QR Code
                                    </button>
                                )}
                                {salvando ? (
                                    <div className="spinner-border spinner-border-sm mx-3 text-primary" role="status" />
                                ) : (
                                    <button disabled={loadingStatus} onClick={salvar} className="btn btn-outline-success mx-1 text-nowrap">{novoConteudo ? 'criar conteúdo' : 'salvar alterações'}</button>
                                )}
                                {botaoStatus(false)}
                                <button onClick={voltar} className="btn btn-outline-secondary mx-1">voltar</button>
                            </div>
                        </div>
                    </div>
                    {/* Layout mobile */}
                    <div className="header-artigo-mob d-lg-none">
                        <div className="row no-gutters">
                            <div className="col-12">
                                <div className="row no-gutters align-items-center">
                                    <div className="col-3 px-4 py-4">
                                        <i className="icones fas fa-long-arrow-alt-left" onClick={voltar}></i>
                                    </div>
                                    <div className="col-5 py-4 d-flex justify-content-center align-items-center flex-nowrap">
                                        {foiSalvo && linkPublico && (
                                            <button onClick={() => setModalQRCode(true)} className="btn btn-outline-info mx-1" title="QR Code">
                                                <i className="fas fa-qrcode pr-1"></i> QR Code
                                            </button>
                                        )}
                                        {botaoStatus(true)}
                                    </div>
                                    <div className="col-4 text-center py-4 px-4">
                                        {salvando ? (
                                            <div className="spinner-border spinner-border-sm text-primary" role="status" />
                                        ) : (
                                            <button disabled={loadingStatus} onClick={salvar} className="btn btn-outline-success">{novoConteudo ? 'criar' : 'salvar'}</button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <div className="div-artigo text-center">
                <Nav tabs>
                    <NavItem className="d-none d-lg-block">
                        <NavLink className={abaSelecionada === '1' ? 'classe-ativada' : 'classe-inativa'} onClick={() => setAbaSelecionada('1')}>
                            Editar conteúdo
                        </NavLink>
                    </NavItem>
                    {!novoConteudo && (
                        <NavItem className="d-none d-lg-block">
                            <NavLink className={abaSelecionada === '2' ? 'classe-ativada' : 'classe-inativa'} onClick={() => setAbaSelecionada('2')}>
                                Estatísticas de acesso
                            </NavLink>
                        </NavItem>
                    )}
                </Nav>
                <TabContent activeTab={abaSelecionada}>
                    <TabPane tabId="1">
                        <div className="col-12 text-left px-3 py-3">
                            {loading ? (
                                <div className="row no-gutters">
                                    <div className="col-12 text-center">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                </div>
                            ) : (
                                <div className="row">
                                    <div className="col-12 text-center text-lg-left">
                                        <h3 className="d-none d-lg-block">{novoConteudo ? 'Novo' : 'Editar'} conteúdo não listado</h3>
                                        <h5 className="d-lg-none">{novoConteudo ? 'Novo' : 'Editar'} conteúdo não listado</h5>
                                    </div>

                                    <div className="col-12 d-none d-lg-block">
                                        <div className="row no-gutters">
                                            <div className="col-4 py-3">
                                                <small><small>(*)</small> informações obrigatórias</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 d-lg-none">
                                        <div className="row no-gutters">
                                            <div className="col-12 py-2">
                                                <small><small>(*)</small> informações obrigatórias</small>
                                            </div>
                                        </div>
                                    </div>

                                    <fieldset>
                                        <div className="col-12 col-lg-6 py-3">
                                            <label>Título<sup><small>(*)</small></sup></label>
                                            <input
                                                name="titulo"
                                                type="text"
                                                className="form-control"
                                                value={titulo}
                                                onChange={(e) => setTitulo(e.target.value)}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </fieldset>

                                    <fieldset>
                                        <div className="col-12 col-lg-4 py-3">
                                            <div className="form-group">
                                                <label htmlFor="autor">Autor</label>
                                                <Creatable
                                                    id="autor"
                                                    placeholder="Selecione um autor"
                                                    closeMenuOnSelect={true}
                                                    components={makeAnimated()}
                                                    value={autorSelecionado}
                                                    options={autorOptions}
                                                    onChange={handleChangeAutor}
                                                    isClearable
                                                />
                                            </div>
                                        </div>
                                    </fieldset>

                                    <fieldset>
                                        <div className="col-12 col-lg-6 py-3">
                                            <label>Imagem de capa</label>
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-12 col-lg-5">
                                                    <button onClick={() => setOpenModalImagemCapa(true)} className="btn btn-outline-purple">
                                                        {imagemCapa ? 'trocar imagem de capa' : 'escolher imagem de capa'}
                                                    </button>
                                                    {!!imagemCapa && (
                                                        <button onClick={() => setImagemCapa('')} className="btn btn-outline-danger mt-2 d-block">
                                                            <i className="far fa-trash-alt mr-1"></i> remover imagem de capa
                                                        </button>
                                                    )}
                                                </div>
                                                {!!imagemCapa && (
                                                    <div className="col-12 col-lg-7 py-2 py-lg-0">
                                                        <ImagemFukyo className="img img-fluid mx-auto p-2" src={imagemCapa} alt={titulo} style={{ maxHeight: 120 }} />
                                                    </div>
                                                )}
                                                {!imagemCapa && !!imagemCapaSalva && (
                                                    <div className="col-12 col-lg-7 py-2 py-lg-0">
                                                        <small className="text-danger d-block">A imagem de capa será removida ao salvar as alterações.</small>
                                                        <button onClick={() => setImagemCapa(imagemCapaSalva)} className="btn btn-outline-primary btn-sm">desfazer</button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 py-3">
                                            <label htmlFor="legenda">Legenda da imagem de capa</label>
                                            <SimpleHtmlEditor value={legendaCapaHtml} onChange={setLegendaCapaHtml} editorClassName="custom-editor-legenda border px-3" />
                                        </div>
                                    </fieldset>

                                    <fieldset>
                                        <div className="col-12 col-lg-12 py-3">
                                            <label>PDF</label>
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-12 col-lg-3">
                                                    <button disabled={novoConteudo} onClick={() => setModalPdf(true)} className="btn btn-outline-purple">
                                                        {pdf && !pdfRemovido ? 'gerenciar PDF' : 'adicionar PDF'}
                                                    </button>
                                                    {!!pdf && !pdfRemovido && (
                                                        <button onClick={() => setPdfRemovido(true)} className="btn btn-outline-danger mt-2 d-block">
                                                            <i className="far fa-trash-alt mr-1"></i> remover PDF
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="col-12 col-lg-9 py-2 py-lg-0">
                                                    <p><small className="text-muted">Para melhor experiência do usuário, recomendamos o uso de uma imagem de capa.</small></p>
                                                    {novoConteudo ? (
                                                        <small className="text-muted">Crie o conteúdo para poder enviar um PDF.</small>
                                                    ) : pdfRemovido ? (
                                                        <>
                                                            <small className="text-danger d-block">O PDF será removido ao salvar as alterações.</small>
                                                            <button onClick={() => setPdfRemovido(false)} className="btn btn-outline-primary btn-sm">desfazer</button>
                                                        </>
                                                    ) : pdf && (
                                                        <>
                                                            <a target="_blank" rel="noopener noreferrer" href={pdf}><i className="far fa-file-pdf mr-1 text-primary"></i><span className="text-primary">visualizar PDF</span></a>
                                                            <small className={`d-block ${downloadHabilitado ? 'text-info' : 'text-secondary'}`}>
                                                                Download {downloadHabilitado ? 'habilitado' : 'desabilitado'}
                                                            </small>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>

                                    <div className="col-12 py-3">
                                        <label htmlFor="descricao">Descrição:</label>
                                        <SimpleHtmlEditor value={descricaoHtml} onChange={setDescricaoHtml} editorClassName="custom-editor-descricao border px-3" />
                                    </div>

                                    <div className="col-12 py-3">
                                        <label htmlFor="texto">Texto:</label>
                                        <ArticleTextEditor initialValue={textoHtml} onChange={setTextoHtml} />
                                    </div>

                                    {foiSalvo && linkPublico && (
                                        <div className="col-12 col-lg-6 py-3">
                                            <label>Link público</label>
                                            <input type="text" className="form-control" readOnly value={linkPublico} />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </TabPane>

                    {!novoConteudo && (
                        <TabPane tabId="2">
                            <div className="col-12 text-left px-3 py-3">
                                <div className="row">
                                    <div className="col-12 text-center text-lg-left">
                                        <h3 className="d-none d-lg-block">Estatísticas de acesso</h3>
                                    </div>
                                </div>
                                {!estatisticas ? (
                                    <div className="col-12 my-4">
                                        <div className="alert alert-secondary text-center m-0">
                                            Ainda não há acessos registrados para este conteúdo.
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-12 my-4">
                                        <div className="card">
                                            <div className="card-header">
                                                <strong>Resumo</strong>
                                            </div>
                                            <div className="card-body">
                                                <div className="row text-center">
                                                    <div className="col-6">
                                                        <span className="featured-number">{estatisticas.acessos}</span><br />
                                                        <span>Total de acessos</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="featured-number">{estatisticas.downloads}</span><br />
                                                        <span>Total de downloads</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </TabPane>
                    )}
                </TabContent>
            </div>

            <Modal className="modal-upload-imagem" size="lg" isOpen={openModalImagemCapa} toggle={() => setOpenModalImagemCapa(false)}>
                <ModalHeader toggle={() => setOpenModalImagemCapa(false)}>
                    Upload de imagem - Capa
                </ModalHeader>
                <ModalBody>
                    <ImagesUpload
                        plataforma="Capa"
                        toggle={() => setOpenModalImagemCapa(false)}
                        onChangeInput={(e) => setImagemCapa(e.target.value)}
                        imgNoTexto={false}
                        alteracao={true}
                        realizaBusca={!!imagemCapa}
                        urlImagemBusca={imagemCapa}
                    />
                </ModalBody>
            </Modal>

            {!novoConteudo && (
                <ModalPdfsAdicionais
                    modoSimples
                    tituloModal="PDF do conteúdo"
                    mensagemSemArquivos="Não existe PDF cadastrado para este conteúdo."
                    isOpen={modalPdf}
                    toggle={() => setModalPdf(false)}
                    arquivosAdicionais={arquivosPdf}
                    urlUpload={`/conteudo/nao-listados/${contentId}/upload/pdf`}
                    onUploadSucesso={onUploadPdf}
                    onToggleDownload={alteraDownloadPdf}
                    onRemoverArquivo={() => { setPdfRemovido(true); setModalPdf(false); }}
                />
            )}

            <SuccessModal
                isOpen={!!successMessage}
                message={successMessage}
                closeSuccessModal={() => setSuccessMessage('')}
            />

            <ErrorModal
                isOpen={hasError}
                message={errorMessage}
                closeErrorModal={fecharErrorModal}
            />

            <ModalQRCode
                isOpen={modalQRCode}
                toggle={() => setModalQRCode(false)}
                conteudo={{ _id: contentId, titulo, codigo }}
            />
        </div>
    );
};

export default UnlistedArticleDetails;
